module.exports = __webpack_public_path__ + "img/chatJayuProfile.6bec8b9.png";